import script from "./Help.vue?vue&type=script&setup=true&lang=ts"
export * from "./Help.vue?vue&type=script&setup=true&lang=ts"

import "./Help.vue?vue&type=style&index=0&id=bb4d72be&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb4d72be"]])

export default __exports__